(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 700 && 'IntersectionObserver' in window) {

    const enhanceCard = (card) => {
      if (card.dataset.scrollEnhanced) return;

      const productHandle = card.querySelector('a')?.href?.split('/products/')[1];
      if (!productHandle) return;
      card.dataset.scrollEnhanced = true;

      const oldMedia = card.querySelector('.product-card__media');
      if (!oldMedia) return;

      const firstImg = oldMedia.querySelector('img');
      if (!firstImg) return;

      fetch(`/products/${productHandle}.js`)
        .then(r => r.json())
        .then(product => {
          const images = product.images.slice(0, 3);
          const extraImages = images.filter(src => !firstImg.src.includes(src));

          // précharge toutes les images
          const preload = images.map(src => new Promise(res => {
            const img = new Image();
            img.onload = res;
            img.src = src;
          }));

          Promise.all(preload).then(() => {
            // crée le carrousel mais ne remplace rien encore
            const wrapper = document.createElement('div');
            wrapper.className = 'product-card-scroll';
            wrapper.style.cssText = `
              display: flex;
              overflow-x: auto;
              scroll-snap-type: x mandatory;
              -webkit-overflow-scrolling: touch;
              gap: 0;
              width: 100%;
              aspect-ratio: 4 / 5;
              opacity: 0;
              position: absolute;
              top: 0;
              left: 0;
            `;

            const makeImg = (src) => {
              const img = document.createElement('img');
              img.src = src;
              img.decoding = 'async';
              img.style.cssText = `
                flex: 0 0 100%;
                width: 100%;
                aspect-ratio: 4 / 5;
                height: 100%;
                object-fit: cover;
                scroll-snap-align: center;
                display: block;
              `;
              return img;
            };

            const firstSrc = firstImg.src.split('?')[0];
            wrapper.appendChild(makeImg(firstSrc));
            extraImages.forEach(src => wrapper.appendChild(makeImg(src)));

            // insère le nouveau carrousel au-dessus sans retirer l’ancien
            oldMedia.style.position = 'relative';
            oldMedia.appendChild(wrapper);

            // petit délai pour garantir que le DOM soit prêt avant fondu
            requestAnimationFrame(() => {
              wrapper.style.transition = 'opacity 0.25s ease';
              wrapper.style.opacity = '1';
            });

            // supprime uniquement après le fondu
            setTimeout(() => {
              Array.from(oldMedia.children).forEach(el => {
                if (el !== wrapper) el.remove();
              });
            }, 300);
          });
        })
        .catch(err => console.warn('Erreur chargement images produit', err));
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          enhanceCard(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '150px' });

    document.querySelectorAll('.product-card').forEach(card => observer.observe(card));
  }
});

  } catch(e) { console.error(e); }
})();
})();
